import { Outlet } from "react-router-dom";
import React from "react";
import SideBar from "../pages/me/components/sidebar";
import {Helmet} from 'react-helmet'
import MobileNav from "../pages/me/components/MobileNav";
function ProfileLayout() {
  return (
    <>
      <Helmet>
        ‍<title>حسابي - محصول</title>‍
        <meta property="og:site_name" content="Mahsool" />
        <meta name="keywords" content="Mahsool" />
        <meta property="og:title" content="حسابي - محصول" />
        <meta property="og:description" content="mahsool" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="flex flex-col lg:flex-row justify-between w-screen h-auto relative">
        <div className="lg:hidden">
          <MobileNav />
        </div>
        <div className="lg:w-[83%] overflow-x-hidden  h-auto">
          <Outlet />
        </div>
        <div className="overflow-x-hidden overflow-y-auto invisible lg:visible fixed right-0 w-full lg:w-auto lg:px-0 px-4 lg:right-4">
          <SideBar />
        </div>
      </div>
    </>
  );
}

export default ProfileLayout;
